export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-18.jpg'),
        title: '网络安全',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '网络安全对企业运营至关重要',
      description: `<p style="font-size:1.05rem">在互联网时代，网络安全对业务运营至关重要。 为了保护您的网络系统的硬件，软件和数据不被意外或恶意原因损坏，更改或泄露，安全系统连续，可靠和正常运行，以便网络服务不会中断。</p>
<p>MaesInfo拥有一流的Java工程师和高级软件开发工程师，以及思科，CCIE网络专家，旨在为您提供完善的专业服务，计算机软件安全，运营服务安全，数据安全等。</p>`
    },
    {
      title: '对于网络安全，MaesInfo可以:',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-18.jpg')+`)"></span>
      <span class="list">
      <i></i>开发和升级网络安全保护软件<br/>
      <i></i>更新和升级安全保护系统，以防止数据泄漏和损坏

      </span>`
    }
  ]
}
